export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Электрондық чекті белсендіру"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Депозиттік шот"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сан"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сериялар"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Белсендіру коды"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Тексеру"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Іске қосу"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Электрондық чекті белсендіру"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сома"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Күй"])},
  "status": {
    "issued": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Белсенді"])},
    "activated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Белсендірілген"])},
    "cancelled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Бас тартылды"])},
    "activating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Белсендірілуде"])},
    "returning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Қайтару"])},
    "prepare": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Күтілуде"])}
  }
}